import { NgModule } from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {GeneralService} from './service/general-service';
import {KetquaComponent} from './component/public/ketqua/ketqua.component';
const routes: Routes = [
  /*{
    path: '',
    component: LoginComponent,
  },*/
  {
    path: 'auth',
    loadChildren: () =>
      import('./component/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'ket-qua',
    loadChildren: () => import('./component/auth/emulator/emulator.module').then(m => m.EmulatorModule),
  },
  {
    path: 'ket-qua-test',
    component: KetquaComponent,
  },
  /*{
    path: 'login',
    component: LoginComponent,
    children: [
      {
        path: 'layout',
        loadChildren: () => import('./component/admin-layout/layout.module').then(m => m.LayoutModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./component/auth/auth.module').then(m => m.AuthModule)
      }
    ],
    data: {
      breadcrumb: 'Home',
    }
  },*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [GeneralService],
})
export class AppRoutingModule { }
